<script>
/**
 * @overview 场景管理 - 列表
 *
 * @author huojinzhao
 */

import { mapGetters } from 'vuex';
import mapUtils from "@/utils";
import { isFastExecute } from "../../utils/common";
import ThemeItem from "./components/ListItem.vue";
import AppTree from './../../components/AppTree/index.vue';
import AppCopyOrMove from "./../../components/AppCopyOrMove/index.vue";
import AddMenu from './AddMenu.vue';
import * as sceneManageServer from '../../api/sceneManage';

export default {
  name: "ThemeList",

  components: {
    ThemeItem,
    AppTree,
    AppCopyOrMove,
    AddMenu,
  },

  data: () => ({
    isCopyOrMove: false, // 复制或移动弹窗
    showType: 'copy', // 复制或移动类型
    showData: [], // 复制或移动数据集
    optId: '', // 操作id

    selectedId: '', // 菜单选中id
    isAddTheme: false, // 添加场景弹窗

    menu: [], // [{ id: 12, value: '菜单1' }, { id: 13, value: '菜单2' }, { id: 14, value: '菜单3' }],
    list: {
      data: [],
    },

    query: {
      per_page: 20,
    },

    loading: {
      fetch: false,
    },
  }),
  computed: {
    ...mapGetters(['getPermissionsCopyScene', 'getPermissionsMoveScene']),
  },
  created() {
    this.init();
  },
  beforeRouteUpdate(to, from, next) {
    // this.fetchList(to);

    next();
  },
  methods: {
    ...mapUtils("list", ["fetch", "deleteAlert", "routeTypePageIndex"]),
    async init() {
      const menus = await sceneManageServer.queryThemeType();
      this.menu = (menus.courseware_theme_types || []).map(v => ({
          id: v.id,
          value: v.name,
        }));
      this.selectedId = Number(this.$route.query.type) || this.menu[0].id;
      this.query['equal[type_id]'] = this.selectedId;
      this.fetchList();
    },
    queryName(nameQuery) {
      this.query = { ...this.query, ...nameQuery };

      const query = { page: 1, ...this.query };

      this.fetchList();
    },

    fetchList(route = this.$route) {
      const query = { ...route.query, ...this.query };

      this.loading.fetch = true;

      this.$list_fetch("/theme", query)
        .then((data) => {
          this.list = data;
        })
        .finally(() => {
          this.loading.fetch = false;
        });
    },

    themeEdit({ id } = {}) {
      id
        ? this.$router.push({ path: `/theme/edition/${id}`, query: { type: this.selectedId } })
        : this.$router.push({ path: `/theme/edition`, query: { type: this.selectedId } });
    },

    themeDelete({ id }) {
      this.$list_deleteAlert(id, this.list.data, "主题", "/theme");
    },

    // 复制
    themeFuzhi(item) {
      console.log('复制==>');
      this.optId = item.id;
      // this.showCopyOrMove('copy');
      !isFastExecute() && sceneManageServer
        .copyTheme({ id: item.id })
        .then((res) => {
          if (res) {
            this.$message.success('复制成功');
            this.clearAll();
            this.fetchList();
          }
        })
        .catch((err) => {
          this.$message.error('复制失败');
        });
    },

    // 移动
    themeMove(item) {
      console.log('移动==>');
      this.optId = item.id;
      this.showCopyOrMove('move');
    },

    // 复制或移动业务
    showCopyOrMove(type) {
      this.isCopyOrMove = true;
      this.showType = type;
      const logs = this.menu.map(v => ({ key: v.id, value: v.value }));
      // TODO 获取复制或移动的数据
      switch (type) {
        case 'copy':
          this.showData = logs;
          this.$refs.optLog.selected(this.selectedId);
          break;
        case 'move':
          this.showData = logs && logs.filter(v => `${v.key}` !== `${this.selectedId}`);
          break;
        default:
      }
    },

    // 复制或移动回调
    async onCopyOrMove(select, type) {
      try {
        const res = null;
        switch (type) {
          case 'copy':
            console.log('复制回调==>', type);
            break;
          case 'move':
            console.log('移动回调==>', type);
            await sceneManageServer.moveThemeType({ id: this.optId, type_id: select });
            break;
          default:
        }
        this.clearAll();
        this.queryName();
      } catch (e) {
        this.$message.error('操作失败', e);
      }
    },

    // 添加场景回调
    onAddTheme(e) {
      // alert(e);
      this.init();
    },
    // 选中菜单回调
    onBack(item) {
      this.selectedId = item.id;
      // 刷新
      this.query.page = 1;
      this.$list_routeTypePageIndex({ page: 1, type: this.selectedId });
      this.query['equal[type_id]'] = this.selectedId;
      this.fetchList();
    },

    queryPage(value) {
      this.query.page = value;

      this.fetchList();
    },
    // 清除设置
    clearAll() {
      this.optId = '';
    },
  },
};
</script>

<template>
  <div class="theme_box">
    <AppTree
      :select="selectedId"
      :is-add="true"
      :form="menu"
      @onAdd="isAddTheme=true"
      @onBack="onBack"
    />
    <div class="list-box">
      <div class="search-box">
        <AppQueryName
          :value.sync="$route.query['like[name]']"
          @query="queryName"/>
      </div>
      <AppList
        v-loading="loading.fetch"
        class="theme-list"
      >
        <AppLabel
          class="theme-list__item"
          width="240px"
          @create="themeEdit"
        />

        <ThemeItem
          v-for="item in list.data"
          :key="item.id"
          :data="item"
          :is-fuzhi-permissions="getPermissionsCopyScene"
          :is-move-permissions="getPermissionsMoveScene"
          class="theme-list__item"
          @delete="themeDelete"
          @update="themeEdit"
          @fuzhi="themeFuzhi"
          @move="themeMove"
        />
      </AppList>
      <TheFooter>
        <AppPagination
          :list="list"
          :size="query.per_page"
          class="view-material__pagination"
          router
          @changeIndex="queryPage"
        />
      </TheFooter>
    </div>
    <AppCopyOrMove
      ref="optLog"
      :visible.sync="isCopyOrMove"
      :data="showData"
      :type="showType"
      @success="onCopyOrMove"
    />
    <AddMenu
      :visible.sync="isAddTheme"
      @success="onAddTheme"
    />
  </div>
</template>

<style lang="postcss" scoped>
  .search-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;
    padding: 30px;
    padding-bottom: 0px;
  }
.theme-list {
  min-width: 100%;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-content: flex-start;
}

.theme-list__item {
  margin: 18px 14px;
}
  .theme_box {
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: row;
    justify-content: flex-start;
  }
  .list-box{
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
  }
</style>
